import {
	getUserAccessRestrictionStatus,
	type UserAccessRestrictionQueryParams,
	type UserAccessRestrictionStatus,
	useUserInfo
} from "~/domain/user-session"
import { useQuery } from "@tanstack/react-query"


/**
 * Проверяет доступ пользователя с учетом указанных ограничений и возвращает статус {@link UserAccessRestrictionStatus}
 * @hook
 * @category Hook
 */
export function useUserAccessRestrictionStatus({
												   objects,
												   ignoreNotChangedPassword,
												   secureOp
											   }: UserAccessRestrictionQueryParams): UserAccessRestrictionStatus {

	const userInfo = useUserInfo()

	const query = useQuery({
		queryKey: ["getUserAccessRestrictionStatus",  userInfo?.id, objects, ignoreNotChangedPassword, secureOp],
		queryFn: async () => await getUserAccessRestrictionStatus({ objects, ignoreNotChangedPassword, secureOp }),
		//staleTime: ({ state }) => state.data?.code === UserAccessRestrictionCode.ACCESS_IS_ALLOWED ? Infinity : 0
	})

	if (query.error) {
		throw query.error
	}

	if (query.status === "pending") {
		return {
			code: 0,
			objectIndex: undefined,
			isPending: true
		}
	}

	return {
		...query.data,
		isPending: false
	}
}
